import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { format, getConnectorV1Name } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ServiceNowLinkedService } from '../linkedservice/servicenow.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';

@Metamodel.model({
    name: ModelConstants.serviceNowDataset,
    disabled: isTridentInIframe(),
    display: [
        format(shellStringResources.ModelName_DatasetTemplate,
            getConnectorV1Name(shellStringResources.ServiceNow_DisplayText)),
        format(shellStringResources.ModelName_DatasetsTemplate,
            getConnectorV1Name(shellStringResources.ServiceNow_DisplayText))
    ],
    constraints: {
        linkedService: {
            model: ServiceNowLinkedService.MODEL // Linked service redefined
        }
    }
})
export class ServiceNowObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
